export default __webpack_public_path__ + "static/media/image-ph-study-main-1-n-m.eb8a30ec.webp";